(function () {
  var DATA_CACHE = null;

  function normalize(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function uniqueInOrder(values) {
    var seen = {};
    return values.filter(function (value) {
      if (!value || seen[value]) return false;
      seen[value] = true;
      return true;
    });
  }

  function getYearsForModel(records, make, model) {
    var years = [];
    records.forEach(function (item) {
      if (normalize(item.make) !== normalize(make) || normalize(item.model) !== normalize(model)) return;
      for (var year = Number(item.year_start); year <= Number(item.year_end); year += 1) {
        years.push(String(year));
      }
    });
    return uniqueInOrder(years).sort(function (a, b) {
      return Number(b) - Number(a);
    });
  }

  function getProductUrl(root, item) {
    if (item.product_url) return item.product_url;
    if (item.product_handle) return "/products/" + item.product_handle;
    return root.dataset.productUrl || "";
  }

  function getCartUrl(item) {
    if (!item.variant_id) return "";
    return "/cart/add?id=" + encodeURIComponent(item.variant_id) + "&quantity=1";
  }

  function setOptions(select, values, placeholder) {
    select.innerHTML = "";
    var first = document.createElement("option");
    first.value = "";
    first.textContent = placeholder;
    select.appendChild(first);

    values.forEach(function (value) {
      var option = document.createElement("option");
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });
  }

  function findMatch(records, make, model, year) {
    var selectedYear = Number(year);
    return records.find(function (item) {
      var aliases = Array.isArray(item.aliases) ? item.aliases : [];
      var modelNames = [item.model].concat(aliases);
      var modelMatch = modelNames.some(function (name) {
        return normalize(name) === normalize(model);
      });

      return (
        normalize(item.make) === normalize(make) &&
        modelMatch &&
        selectedYear >= Number(item.year_start) &&
        selectedYear <= Number(item.year_end)
      );
    });
  }

  function showResult(root, item, selection) {
    var result = root.querySelector("[data-fitment-result]");
    var badge = root.querySelector("[data-fitment-badge]");
    var title = root.querySelector("[data-fitment-result-title]");
    var message = root.querySelector("[data-fitment-result-message]");
    var enginesWrap = root.querySelector("[data-fitment-engines-wrap]");
    var engines = root.querySelector("[data-fitment-engines]");
    var note = root.querySelector("[data-fitment-note]");
    var link = root.querySelector("[data-fitment-product-link]");
    var cartLink = root.querySelector("[data-fitment-cart-link]");

    result.hidden = false;
    result.className = "vehicle-fitment__result";
    enginesWrap.hidden = true;
    link.hidden = true;
    if (cartLink) cartLink.hidden = true;
    link.removeAttribute("href");
    if (cartLink) cartLink.removeAttribute("href");

    if (!item) {
      result.classList.add("vehicle-fitment__result--no");
      badge.textContent = "Not confirmed";
      title.textContent = "We could not confirm compatibility";
      message.textContent =
        selection.make + " " + selection.model + " " + selection.year + " is not listed in the current fitment database.";
      note.textContent = "Please contact support before ordering, or check another vehicle.";
      return;
    }

    var confidence = item.confidence || "confirmed";
    var isConfirmed = confidence === "confirmed";
    result.classList.add(isConfirmed ? "vehicle-fitment__result--yes" : "vehicle-fitment__result--maybe");
    badge.textContent = isConfirmed ? "Compatible" : "Engine check recommended";
    title.textContent = isConfirmed ? "This product fits your selected vehicle" : "This vehicle may be compatible";
    message.textContent =
      selection.make + " " + selection.model + " " + selection.year + " is covered by our compatibility data.";

    if (Array.isArray(item.engines) && item.engines.length) {
      enginesWrap.hidden = false;
      engines.textContent = item.engines.join(" / ");
    }

    note.textContent = item.note || "Engine is shown as a reference only. Customers do not need to select it unless they want to double-check before purchase.";

    if (root.dataset.resultMode !== "message_only") {
      var url = getProductUrl(root, item);
      var cartUrl = getCartUrl(item);
      if (cartUrl && cartLink) {
        cartLink.href = cartUrl;
        cartLink.hidden = false;
      }
      if (url) {
        link.href = url;
        link.hidden = false;
      }
    }
  }

  function initChecker(root, records) {
    var makeSelect = root.querySelector("[data-fitment-make]");
    var modelSelect = root.querySelector("[data-fitment-model]");
    var yearSelect = root.querySelector("[data-fitment-year]");
    var form = root.querySelector("[data-fitment-form]");
    var submit = root.querySelector("[data-fitment-submit]");
    var reset = root.querySelector("[data-fitment-reset]");
    var status = root.querySelector("[data-fitment-status]");
    var result = root.querySelector("[data-fitment-result]");

    var makePlaceholder = makeSelect.querySelector("option").textContent;
    var modelPlaceholder = modelSelect.querySelector("option").textContent;
    var yearPlaceholder = yearSelect.querySelector("option").textContent;
    var makes = uniqueInOrder(records.map(function (item) { return item.make; }));

    setOptions(makeSelect, makes, makePlaceholder);
    status.textContent = "";

    makeSelect.addEventListener("change", function () {
      var make = makeSelect.value;
      var models = uniqueInOrder(records.filter(function (item) {
        return normalize(item.make) === normalize(make);
      }).map(function (item) {
        return item.model;
      }));

      setOptions(modelSelect, models, modelPlaceholder);
      setOptions(yearSelect, [], yearPlaceholder);
      modelSelect.disabled = !make;
      yearSelect.disabled = true;
      submit.disabled = true;
      result.hidden = true;
      reset.hidden = !make;
    });

    modelSelect.addEventListener("change", function () {
      var years = getYearsForModel(records, makeSelect.value, modelSelect.value);
      setOptions(yearSelect, years, yearPlaceholder);
      yearSelect.disabled = !modelSelect.value;
      submit.disabled = true;
      result.hidden = true;
    });

    yearSelect.addEventListener("change", function () {
      submit.disabled = !yearSelect.value;
      result.hidden = true;
    });

    reset.addEventListener("click", function () {
      makeSelect.value = "";
      setOptions(modelSelect, [], modelPlaceholder);
      setOptions(yearSelect, [], yearPlaceholder);
      modelSelect.disabled = true;
      yearSelect.disabled = true;
      submit.disabled = true;
      reset.hidden = true;
      result.hidden = true;
    });

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var selection = {
        make: makeSelect.value,
        model: modelSelect.value,
        year: yearSelect.value
      };
      var item = findMatch(records, selection.make, selection.model, selection.year);
      showResult(root, item, selection);
    });
  }

  function loadData(url) {
    if (DATA_CACHE) return Promise.resolve(DATA_CACHE);

    return fetch(url, { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("Could not load vehicle fitment data.");
        return response.json();
      })
      .then(function (data) {
        DATA_CACHE = Array.isArray(data) ? data : data.records || [];
        return DATA_CACHE;
      });
  }

  function boot() {
    document.querySelectorAll("[data-vehicle-fitment]").forEach(function (root) {
      var status = root.querySelector("[data-fitment-status]");
      status.textContent = "Loading compatibility data...";

      loadData(root.dataset.dataUrl)
        .then(function (records) {
          initChecker(root, records);
        })
        .catch(function () {
          status.textContent = "Compatibility data is unavailable. Please refresh the page or contact support.";
        });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
